module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAAAXNSR0IArs4c6QAAAOlJREFUOE/FlE0KglAUhe9REFxG0AbkKoJ7sh9ag02qrRRN+l1B8NxANalFFD6QG0aCRGQ+B73hg/Nx7t+BUmpDRF0RGQVBsCSDB6WUVHQrAH1mPjdhvUMKbUZEE631OIqi+y+wT5BSdwUwYOZFHegb5KkVkY1lWfG3EmshLxdaRKYAEt/3b+/OfoVUSxwy87wKagoptbs8z+MwDI/Fhymk0GoimrmuO24DKV0d/g55TsxxHONytrZtx57nnUwaW2yx8Yg1gEmWZcmne6ptbNu1v7ysGx1guygAsCaiXuNQStN0LyKdNvH4AEjKlnYKMAZXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.png
// module id = KBZJ
// module chunks = 1